import type { DocumentStatus } from "../api/types.js";
import { Badge, type BadgeTone } from "./Badge.js";

const TONE: Record<DocumentStatus, BadgeTone> = {
  none: "slate",
  partial: "amber",
  complete: "emerald",
};

const LABEL: Record<DocumentStatus, string> = {
  none: "None",
  partial: "Partial",
  complete: "Complete",
};

export function DocumentStatusBadge({
  status,
  children,
}: {
  status: DocumentStatus;
  children?: React.ReactNode;
}) {
  return <Badge tone={TONE[status]}>{children ?? LABEL[status]}</Badge>;
}
